import axios, {
    Method
} from "axios";

export interface CustomFetchProps {
    method: Method,
    url: string,
    data?: any,
    authenticated?: boolean,
    params?: any
}

export interface CustomFetchResponse {
    data: any;
    status: number;
    message?: string
}

const headers = () => ({
    "Content-Type": "application/json",
    Accept: "application/json"
})

const authHeader = () => ({
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("access_token") || undefined
})

export const CustomFetch = async (props: CustomFetchProps): Promise<CustomFetchResponse> => {
    let response: CustomFetchResponse = {status: 0, data: null}
    try{
        const axiosResponse = await axios({
            method: props.method,
            url: props.url,
            data: props.data,
            params: props.params,
            headers: props.authenticated ? authHeader() : headers(),
        })
        response.status = axiosResponse.status
        response.data = axiosResponse.data

        return response
    } catch (error) {
        if(axios.isAxiosError(error)){
            console.log("Axios error")
            console.log(error)
            response.status = error.response?.status ? error.response.status : 0
            response.data = error.response?.data
            response.message = error.message

            return response
        }else {
            console.log("Generic error")
            console.error(error)
            response.data = error
            return response
        }
    }

}